'use client'
import * as React from 'react'
import { cn } from '../../helpers/utils.js'
import SwiperBox from '../SwiperBox/index.js'
import type { Img } from '../../types/props.js'
import { withLayout } from '../../shared/Styles.js'
import { Picture, Text } from '../../components/index.js'

export type SelectStoreDataType = {
  title: string
  desc: string
  img: Img
  mobileImg: Img
  padImg: Img
  miniImg: Img
  // pay: {
  //   img: Img
  // }[]
  // delivery: {
  //   img: Img
  // }[]
  // service: {
  //   title: string
  //   img: Img
  // }[]
}

interface SelectStoreType extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    list: SelectStoreDataType[]
  }
}

const SelectStore = ({ data, className, ...rest }: SelectStoreType) => {
  const { list } = data
  // const number = list?.[2]?.service?.length || 0
  return (
    <>
      <div {...rest} className={cn('', className)}>
        <div className="laptop:grid-cols-3 tablet:grid-cols-2 grid grid-cols-1 gap-4">
          {list.map((item, index) => (
            <div
              key={index}
              className="lg-desktop:aspect-[543/320] laptop:aspect-[440/280] tablet:aspect-[346/240] select-store-wrapper rounded-box relative flex aspect-[358/240] flex-col overflow-hidden bg-[#EAEAEC]"
            >
              <Picture
                className="object-cover"
                imgClassName="w-full object-cover"
                source={`${item?.img?.url}, ${item?.padImg?.url} 1439, ${item?.miniImg?.url} 1023, ${item?.mobileImg?.url} 767`}
              />
              <div className="laptop:px-6 laptop:pb-4 lg-desktop:px-8 lg-desktop:pb-8 px-4 pb-4">
                <Text
                  html={item?.title}
                  className="lg-desktop:text-[24px] text-[20px] leading-[1.2] text-[#080A0F] [&_*_strong]:!font-bold"
                />
                <Text
                  html={item?.desc}
                  className="lg-desktop:text-[16px] line-clamp-1 text-[14px] leading-[1.4] text-[#080A0F] [&_*_strong]:!font-bold"
                />
              </div>
            </div>
          ))}
        </div>
        {/* <div className='grid desktop:grid-cols-3 tablet:grid-cols-2 grid-cols-1 gap-4'>
          {list.map((item, index) => (
            <div key={index} className='bg-[#EAEAEC] rounded-2xl min-h-[240px] laptop:min-h-[280px] lg-desktop:min-h-[320px]'>
              <div className='flex flex-col laptop:p-[24px] lg-desktop:p-[32px] p-[16px] justify-start h-full'>
                <div className="flex flex-col justify-center flex-1">
                
                {item?.pay && (
                  <div className='flex gap-[16px] flex-wrap items-center justify-center laptop:gap-[24px]'>
                  {item?.pay?.map((pay, ind)=>{
                    return (
                      <div key={ind} className='laptop:w-[60px] w-[48px]'>
                        <Picture
                            className=" w-full"
                            imgClassName=""
                            source={pay?.img?.url}
                            alt={pay?.img?.alt || ''}
                        />
                      </div>
                    )
                  })}
                </div>
                )}
                
                {
                 item?.delivery && (
                  <div className='flex gap-[24px] items-center justify-center'>
                    {item?.delivery?.map((delivery, ind)=>{
                    return (
                      <div key={ind} className=''>
                        <Picture
                            className={` ${ind === 0 ? 'laptop:w-[174px] w-[116px]' : 'laptop:w-[75px] w-[50px]'}`}
                            imgClassName=""
                            source={delivery?.img?.url}
                            alt={delivery?.img?.alt || ''}
                        />
                      </div>
                    )
                  })}
                  </div>
                 ) 
                }
                
                {
                  item?.service && (
                    <div className=' desktop:gap-[24px] gap-[8px] tablet:gap-[12px] laptop:gap-[28px] grid l-tablet:grid-cols-2 tablet:flex flex-wrap desktop:grid-cols-4 items-center justify-center'>
                      {item?.service?.map((service, ind)=>{
                        // 判断：只对第五条（index === 4）应用响应式显示/隐藏
                        const isFifth = ind === 4;
                        return (
                          <div key={ind} className={`
                            flex flex-col items-center desktop:h-full  w-[157px] justify-start desktop:w-[81px]
                            ${isFifth ? 'laptop:flex desktop:hidden hidden' : ''} 
                          `}>
                            <div className='w-[70px] desktop:w-[54px]'>
                              <Picture
                              className=""
                              imgClassName="w-full h-auto"
                              source={service?.img?.url}
                              alt={service?.img?.alt || ''}
                            />
                            </div>
                            <div className='text-center'>
                            <Text html={service?.title} className=' font-bold text-[12px] mt-[8px] leading-[1.4]' />
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )
                }
                </div>
                <div className='mt-auto'>
                  <Text html={item?.title} className='text-[20px] lg-desktop:text-[24px] [&_*_strong]:!font-bold leading-[1.2] text-[#080A0F]'/>
                  <Text html={item?.desc} className='text-[14px] line-clamp-1 lg-desktop:text-[16px] leading-[1.4] text-[#080A0F]'/>
                </div>
                
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </>
  )
}

export default withLayout(SelectStore)
